<template>
  <div class="pt-3">
    <v-row class="d-flex justify-center">
      <v-col>
        <v-text-field
          label="New Todo"
          outlined
          v-model="newItem"
          @keyup.enter="addItem"
        ></v-text-field>
      </v-col>
      <v-col cols="1">
        <v-btn large color="primary" @click="addItem">Add</v-btn>
      </v-col>
    </v-row>
    <transition-group name="fade">
      <v-card
        class="mx-auto pa-3 ma-2 text-center"
        max-width="400"
        v-for="item in Todos"
        :key="item"
      >
        <v-row class="d-flex justify-space-around">
          <v-col cols="8">
            <v-list-item-title class="headline mb-1">{{
              item.name
            }}</v-list-item-title>
          </v-col>
          <v-col cols="4">
            <v-btn icon color="red" @click="deleteTodo(item.id)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </transition-group>
  </div>
</template>
<script>
import { db } from "../firbase/db";
export default {
  data() {
    return {
      Todos: [],
      newItem: "",
    };
  },
  methods: {
    async addItem() {
      if (this.newItem) {
        await db.collection("TODOS").add({ name: this.newItem });
        this.newItem = "";
      }
    },
    deleteTodo(id) {
      db.collection("TODOS")
        .doc(id)
        .delete();
    },
  },
  firestore: {
    Todos: db.collection("TODOS"),
  },
};
</script>
